import { makeImmutable } from "../../core";
export class ProductTypePackagingFeeRequirement {
    constructor(productTypeIds) {
        this.productTypeIds = productTypeIds;
        makeImmutable(this);
    }
    testProduct(productInstance) {
        return !productInstance.productTypeIds.intersection(this.productTypeIds)
            .isEmpty;
    }
    testModifier(_modifierTypeId, _modifierItemTypeId) {
        return false;
    }
}
